import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Description`}</h3>
    <p><inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` is a file created by `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-shrinkwrap"
      }}><inlineCode parentName="a">{`npm
shrinkwrap`}</inlineCode></a>{`. It is identical to
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`, with one major caveat: Unlike `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`,
`}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` may be included when publishing a package.`}</p>
    <p>{`The recommended use-case for `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` is applications deployed
through the publishing process on the registry: for example, daemons and
command-line tools intended as global installs or `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{`. It's
strongly discouraged for library authors to publish this file, since that
would prevent end users from having control over transitive dependency
updates.`}</p>
    <p>{`If both `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` are present in a
package root, `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` will be preferred over the
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` file.`}</p>
    <p>{`For full details and description of the `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` file format,
refer to the manual page for
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/package-lock-json"
      }}>{`package-lock.json`}</a>{`.`}</p>
    <h3>{`See also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-shrinkwrap"
        }}>{`npm shrinkwrap`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-lock-json"
        }}>{`package-lock.json`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}>{`package.json`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      